// frontend/src/services/couple.service.ts
import api from './api';
import { Couple } from '../types';

interface CreateCoupleData {
  names: string;
  weddingDate: string;
  weddingLocation?: string;
  weddingTheme?: string;
  story?: string;
  proposalStory?: string;
  customUrl?: string;
  fundingGoal?: number;
  partners?: string[];
}

const CoupleService = {
  createCouple: async (coupleData: CreateCoupleData): Promise<Couple> => {
    const response = await api.post<Couple>('/couples', coupleData);
    return response.data;
  },

  getMyCouples: async (): Promise<Couple[]> => {
    const response = await api.get<Couple[]>('/couples/my-couples');
    return response.data;
  },

  getCoupleById: async (id: string): Promise<Couple> => {
    const response = await api.get<Couple>(`/couples/${id}`);
    return response.data;
  },

  getCoupleByCustomUrl: async (customUrl: string): Promise<Couple> => {
    const response = await api.get<Couple>(`/couples/url/${customUrl}`);
    return response.data;
  },

  // Added this method as an alias to keep code consistent
  getCoupleByURL: async (url: string): Promise<Couple> => {
    const response = await api.get<Couple>(`/couples/url/${url}`);
    return response.data;
  },

  updateCouple: async (id: string, coupleData: Partial<CreateCoupleData>): Promise<Couple> => {
    const response = await api.patch<Couple>(`/couples/${id}`, coupleData);
    return response.data;
  },

  deleteCouple: async (id: string): Promise<{ deleted: boolean }> => {
    const response = await api.delete<{ deleted: boolean }>(`/couples/${id}`);
    return response.data;
  }
};

export default CoupleService;